import { useIntl } from "react-intl";
import Markdown from "react-markdown";
import expertImg2 from "../../../../../assets/images/expert-img-2.png";

export const TextWithImageInverse = () => {
  const { formatMessage } = useIntl();

  return (
    <section>
      <div className="container mx-auto">
        <div className="flex justify-center">
          <div className="w-full md:w-3/4 md:pe-8">
            <div className="mb-8">
              <Markdown
                components={{
                  p: ({ children, ...rest }) => (
                    <p className="mb-2 text-2xl" {...rest}>
                      {children}
                    </p>
                  ),
                }}
              >
                {formatMessage({
                  id: "GUIDE_FOR_EXPERT_IMAGE_AND_TEXT_INVERSE_TITLE",
                })}
              </Markdown>
              <Markdown>
                {formatMessage({
                  id: "GUIDE_FOR_EXPERT_IMAGE_AND_TEXT_INVERSE",
                })}
              </Markdown>
            </div>
            <div className="mb-8">
              <Markdown
                components={{
                  p: ({ children, ...rest }) => (
                    <p className="mb-2 text-2xl" {...rest}>
                      {children}
                    </p>
                  ),
                }}
              >
                {formatMessage({
                  id: "GUIDE_FOR_EXPERT_IMAGE_AND_TEXT_INVERSE_TITLE_2",
                })}
              </Markdown>
              <Markdown>
                {formatMessage({
                  id: "GUIDE_FOR_EXPERT_IMAGE_AND_TEXT_INVERSE_2",
                })}
              </Markdown>
            </div>
            <div className="mb-8">
              <Markdown
                components={{
                  p: ({ children, ...rest }) => (
                    <p className="" {...rest}>
                      {children}
                    </p>
                  ),
                }}
              >
                {formatMessage({
                  id: "GUIDE_FOR_EXPERT_IMAGE_AND_TEXT_INVERSE_3",
                })}
              </Markdown>
            </div>
            <div className="mb-8">
              <Markdown
                components={{
                  li: ({ children, ...rest }) => (
                    <li className="flex items-start gap-3 mb-6" {...rest}>
                      <span className="w-3 h-3 rounded-full bg-primary-light flex-shrink-0 mt-2" />
                      <span className="flex-1">{children}</span>
                    </li>
                  ),
                  ul: ({ children, ...rest }) => (
                    <ul className="list-none" {...rest}>
                      {children}
                    </ul>
                  ),
                }}
              >
                {formatMessage({
                  id: "GUIDE_FOR_EXPERT_IMAGE_AND_TEXT_INVERSE_4",
                })}
              </Markdown>
            </div>
            <div className="mb-8">
              <Markdown
                components={{
                  p: ({ children, ...rest }) => (
                    <p className="mb-2 text-2xl" {...rest}>
                      {children}
                    </p>
                  ),
                }}
              >
                {formatMessage({
                  id: "GUIDE_FOR_EXPERT_IMAGE_AND_TEXT_INVERSE_TITLE_3",
                })}
              </Markdown>
              <Markdown
                components={{
                  p: ({ children, ...rest }) => (
                    <p className="mb-6" {...rest}>
                      {children}
                    </p>
                  ),
                }}
              >
                {formatMessage({
                  id: "GUIDE_FOR_EXPERT_IMAGE_AND_TEXT_INVERSE_5",
                })}
              </Markdown>
              <Markdown
                components={{
                  li: ({ children, ...rest }) => (
                    <li className="flex items-start gap-3 mb-6" {...rest}>
                      <span className="w-3 h-3 rounded-full bg-primary-light flex-shrink-0 mt-2" />
                      <span className="flex-1">{children}</span>
                    </li>
                  ),
                  ul: ({ children, ...rest }) => (
                    <ul className="list-none" {...rest}>
                      {children}
                    </ul>
                  ),
                }}
              >
                {formatMessage({
                  id: "GUIDE_FOR_EXPERT_IMAGE_AND_TEXT_INVERSE_6",
                })}
              </Markdown>
            </div>
          </div>
          <div className="hidden md:block w-1/4">
            <img src={expertImg2} alt="Text with image" />
          </div>
        </div>
      </div>
    </section>
  );
};
